import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import posthog from "posthog-js";
import styles from './styles.module.css';
import ReasonButton from "ProfileComponents/CancelSubscriptionV2/ReasonButton";
import Checkmark from "Images/quiz/tier/Checkmark.svg";
const PasswordResetDone = () => {
    useEffect(() => {
        posthog?.capture("$pageview");
    }, []);
    return (_jsxs("div", { className: styles.page, children: [_jsx("img", { style: { width: "50px;" }, src: Checkmark, alt: "checkmark" }), _jsx("h1", { children: "We've sent you an email" }), _jsx("h6", { children: "Follow the instructions in the email to access your active subscription." }), _jsx("h6", { children: "Or click below if you would like to checkout instead." }), _jsxs("div", { className: styles.btn_container, children: [_jsx(ReasonButton, { label: "Go Home", onClick: () => { window.location.href = "/"; } }, "home"), _jsx(ReasonButton, { label: "Continue to Purchase/Checkout", onClick: () => { window.location.href = "/checkout/"; } }, "continue")] })] }));
};
export default PasswordResetDone;
